export class AccountResponse{
    ReturnValue: number;
    Status: number;
    Message: string;
    Exception: any;
}